import { useContext, useEffect, useState } from "react"
import toast from "react-hot-toast"
import { AuthContext } from "../contexts/auth"
import getServices from "../services/getServices"
import putService from "../services/putService"
import postService from "../services/postService"
import deleteService from "../services/deleteService"

const useTemplateFormularioState = () =>{

    const { signOut } = useContext(AuthContext)

    const [submit, setSubmit] = useState(false)
    const [modalSecao, setModalSecao] = useState(false);
    const [modalPergunta,setModalPergunta] = useState(false);
    const [modalConfigPergunta,setModalConfigPergunta] = useState(false);
    const [modalLista, setModalLista] = useState(false)
    
    const [dialogDeleteSecao, setDialogDeleteSecao] = useState(false);
    const [dialogDeletePergunta, setDialogDeletePergunta] = useState(false);    
    
    const [submitTemplateSecoes, setSubmitTemplateSecoes] = useState(false)
    const [submitTemplatePerguntas,setSubmitTemplatePerguntas] = useState(false)
    const [submitTemplateLista, setSubmitTemplateLista] = useState(false)

    const [idLista, setIdLista] = useState(null)



    const urlTemplateFormulario = 'admin/templateformulario/'
    const urlTemplateSecoes = 'admin/templatesecao/'
    const urlTemplatePerguntas = 'admin/templatepergunta/'   
    const urlTemplateSecao = 'admin/templatesecao/' 
    const urlTemplatelista = 'admin/templatelista/' 

//    http://127.0.0.1:8000/api/admin/templatepergunta/?secao_id=13
    
    const [templateFormulario, setTemplateFormulario] = useState({
        tipotarefa: {
            nome: "",
            tem_formulario: false,
            finaliza_com_qrcode: true,            
            ativo: true,                        
            editavel: true,                        
        },
    })
    
    const [templateSecao, setTemplateSecao] = useState(null)
    const [templateSecoes, setTemplateSecoes] = useState([])
    const [templatePergunta, setTemplatePergunta] = useState(null)
    const [templatePerguntas, setTemplatePerguntas] = useState([])
    const [templateListas, setTemplateListas] = useState([])
   

    //if (templatePergunta && templatePergunta?.id && templatePergunta?.tipo_resposta === 2 && !modalLista ){
    useEffect(()=>{
        if (templatePergunta?.tipo_resposta === 2 && !modalLista ){
            _getTemplatelista()
        }

    }, [templatePergunta,modalLista])

    useEffect(()=>{
        if (templateFormulario && templateFormulario?.id){
            _getTemplateSecoes()
        }
    }, [templateFormulario])

    useEffect(()=>{
        if (templateSecao && templateSecao?.id){
            _getTemplatePerguntas()
        }
    }, [templateSecao])

    
    const _getTemplateFormulario = async (id) => {
        if (submit || id === null){
            return;
        }
        
        setSubmit(true)
        let result = await getServices(`${urlTemplateFormulario}${id}/`)
        if (result.type === 'success'){
            setTemplateFormulario(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)

    }    

    const _getTemplatelista = async () =>{

        if (submitTemplateLista){
            return;
        };
        setSubmitTemplateLista(true)
        let result = await getServices(`${urlTemplatelista}`)

        if (result.type === 'success'){
            setTemplateListas(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmitTemplateLista(false)

    }    

    const _getTemplateSecoes = async () => {
        if (submit || templateFormulario?.id === null){
            return;
        }

        setSubmitTemplateSecoes(true)
        let result = await getServices(`${urlTemplateSecoes}?formulario_id=${templateFormulario.id}`)
        if (result.type === 'success'){
            setTemplateSecoes(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmitTemplateSecoes(false)
    }  
    
    const _getTemplatePerguntas = async () =>{
        if (submitTemplateSecoes || templateSecao?.id === null){
            return;
        };
        setSubmitTemplatePerguntas(true)
        let result = await getServices(`${urlTemplatePerguntas}?secao_id=${templateSecao?.id}`)

        if (result.type === 'success'){
            const perguntas = result.data;

            // Verifica se existe pelo menos uma pergunta 
            const precisaDeListas = perguntas.some(p => p.templatelista != null);
            let listas = [];
            if (precisaDeListas) {
                const listasResult = await getServices(`${urlTemplatelista}`);
                if (listasResult.type === 'success') {
                    listas = listasResult.data;
                    setTemplateListas(listas); // atualiza o estado global também
                } else if (listasResult.data?.code === 'token_not_valid') {
                    signOut();
                }
            }            

            // Associa listas às perguntas
            const perguntasComListas = perguntas.map((p) => {
                const lista = listas.find(l => l.id === p.templatelista);
                return {
                    ...p,
                    templatelista_opcoes: lista?.opcoes || [] // insere as opções, se existir
                };
            });
            setTemplatePerguntas(perguntasComListas);
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmitTemplatePerguntas(false)

    }

    const _putTemplateFormulario = async () => {
        if ( templateFormulario.id){
            if (submit){
                return;
            }

            setSubmit(true)
            
            if (templateFormulario){
    
                let result = await putService(`${urlTemplateFormulario}${templateFormulario.id}/`,templateFormulario)
                if (result.type === 'success'){
                    if (result.data?.status){
                        result.data?.status.forEach((mensagem)=>{
                            toast.error(mensagem)
                        })
                    }
                    else{
                        toast.success('alterado com sucesso')
                    }
                }
                else if (result.data?.code === 'token_not_valid'){
                    signOut()
                }
            }
            setSubmit(false)   
        }
    }

    const _postTemplateFormulario = async () => {

        if ( templateFormulario.id === undefined){
            if (submit){
                return;
            }

            setSubmit(true)
            if (templateFormulario){
    
                let result = await postService(`${urlTemplateFormulario}`,templateFormulario.tipotarefa)
                if (result.type === 'success'){
                    if (result.data?.status){
                        result.data?.status.forEach((mensagem)=>{
                            toast.error(mensagem)
                        })
                    }
                    else{
                        setTemplateFormulario(result.data)
                        toast.success('cadastrado com sucesso')
                    }
                }
                else if (result.data?.code === 'token_not_valid'){
                    signOut()
                }
            }
            setSubmit(false)   
        }
    }

    const _salvarSecao = async (secao, closeModal) => {
            if (submit ){
                return;
            }        
            let result = {}

            if (secao?.id){
                result = await putService(`${urlTemplateSecao}${secao.id}/`,secao)
            }
            else {
                result = await postService(`${urlTemplateSecao}`,secao)
                setTemplateSecao(null) 
            }
            
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    if (secao?.id){
                        toast.success('alterado com sucesso')
                    }else {
                        toast.success('cadastrado com sucesso')
                    }
                    closeModal()
                    _getTemplateSecoes()
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
    }

    const _apagarSecao = async (closeModal) => {
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await deleteService(`${urlTemplateSecao}${templateSecao?.id}/`,templateSecao)
        if (result.type === 'success'){
            setTemplateSecao(null) 
            toast.success('apagado')

            //Remove da lista em memoria a seção que foi apagada
            let _arr = templateSecoes.filter(item=> item.id !== templateSecao?.id);
            let cont = 0

            //refaz a ordem da lista de seções
            _arr = _arr.map(item=>{
                cont +=1
                return {
                ...item, ordem:cont}
                    
            })

            //atulaiza a lista de seções no banco de dados
            _templateSecoes(_arr)

            closeModal()
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)        
    }

    const _salvarPergunta = async (closeModalPergunta) => {

        /*
        (0, 'texto'),
        (1, 'condicional'),
        (2, 'opções'),
        (3, 'foto'),
        (4, 'assinatura'), 
        */
        if (submit ){
            return;
        }        
        let result = {}

        if (templatePergunta?.id){
            result = await putService(`${urlTemplatePerguntas}${templatePergunta.id}/`,templatePergunta)
        }
        else {
            result = await postService(`${urlTemplatePerguntas}`,templatePergunta)
        }
        
        if (result.type === 'success'){
            if (result.data?.status){
                result.data?.status.forEach((mensagem)=>{
                    toast.error(mensagem)
                })
            }
            else{
                if (templatePergunta?.id){
                    toast.success('alterado com sucesso')
                }else {
                    toast.success('cadastrado com sucesso')
                }
                closeModalPergunta()
                _getTemplatePerguntas()
                _getTemplateSecoes()
            }
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
    }

    const _apagarPergunta = async (closeModalPergunta) => {
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await deleteService(`${urlTemplatePerguntas}${templatePergunta?.id}/`,templatePergunta)
        if (result.type === 'success'){
            toast.success('apagado')

            //Remove da lista em memoria a seção que foi apagada
            let _arr = templatePerguntas.filter(item=> item.id !== templatePergunta?.id);
            let cont = 0

            //refaz a ordem da lista de perguntas
            _arr = _arr.map(item=>{
                cont +=1
                return {
                ...item, ordem:cont}
                    
            })

            //atualiza a lista de seções no banco de dados
            _templatePerguntas(_arr)

            //_getTemplatePerguntas()
            _getTemplateSecoes()
            closeModalPergunta()
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)        
    }


    const _templateSecoes = async (new_templateSecoes) => {
        if (submit){
            return;
        }

        let json = {
            "secoes": new_templateSecoes
        }        

        setSubmit(true)
        if (new_templateSecoes){

            let result = await putService(`${urlTemplateSecao}`,json)
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    setTemplateSecoes(new_templateSecoes)
                    toast.success('Ordem alterada com sucesso')
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
            else{
                toast.error('Erro ao alterar ordem seção')
            }
        }
        setSubmit(false)   

    }

    const _templatePerguntas = async (new_templatePerguntas) => {
        if (submit){
            return;
        }

        let json = {
            "perguntas": new_templatePerguntas
        }        

        setSubmit(true)
        if (new_templatePerguntas){

            let result = await putService(`${urlTemplatePerguntas}`,json)
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    setTemplatePerguntas(new_templatePerguntas)
                    toast.success('Ordem alterada com sucesso')
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
            else{
                toast.error('Erro ao alterar ordem pergunta')
            }
        }
        setSubmit(false)   

    }    

    return {

        submit: {value: submit, set: _getTemplateFormulario},
        submitTemplateSecoes: {value: submitTemplateSecoes, set: ()=>{console.log('não implementado')}},
        submitTemplatePerguntas :{value:submitTemplatePerguntas, set: _getTemplatePerguntas},

        salvarSecao : {value:submit, set: _salvarSecao},
        apagarSecao : {value:submit, set: _apagarSecao},

        salvarPergunta : {value:submit, set: _salvarPergunta},
        apagarPergunta : {value:submit, set: _apagarPergunta},        

        templateFormulario:{value:templateFormulario,set:setTemplateFormulario}, 
        templateFormularioPut: {value: submit, set: _putTemplateFormulario},
        templateFormularioPost: {value: submit, set: _postTemplateFormulario},

        templateSecao:{value:templateSecao,set:setTemplateSecao}, 
        templateSecoes:{value:templateSecoes,set:_templateSecoes}, 

        templateListas:{value:templateListas, set:_getTemplatelista},         

        modalSecao:{value:modalSecao,set:setModalSecao}, 
        modalPergunta:{value:modalPergunta,set:setModalPergunta}, 
        modalConfigPergunta :{value:modalConfigPergunta,set:setModalConfigPergunta},         
        
        modalLista : {value: modalLista, set: setModalLista},
        idLista : {value:idLista, set: setIdLista},        

        templatePergunta : {value:templatePergunta, set:setTemplatePergunta}, 
        templatePerguntas: {value:templatePerguntas, set:_templatePerguntas}, 

        dialogDeleteSecao: {value:dialogDeleteSecao, set:setDialogDeleteSecao}, 
        dialogDeletePergunta: {value:dialogDeletePergunta, set:setDialogDeletePergunta}, 
    }
}

export default useTemplateFormularioState